export default __webpack_public_path__ + "static/media/protection.f5124d84.svg";